import { Session } from "@/models/Session";
import localStorageService from "@/services/localStorageService";
import { RootState } from "@/store";
import { createNamespacedHelpers, Module } from "vuex";
import { LoginResult } from "../../../models/LoginResult";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export interface AccountState {
    session: Session | null;
    loginResult: LoginResult | null;
    errors: string[] | null;
    loading: boolean;
}

export const SESSION_KEY = "session";

const accountState: AccountState = {
    session: localStorageService.get(SESSION_KEY),
    loginResult: null,
    errors: null,
    loading: false
};

const account: Module<AccountState, RootState> = {
    namespaced: true,
    state: accountState,
    getters: getters,
    mutations: mutations,
    actions: actions
};

export const accountModule = createNamespacedHelpers("account");

export default account;
